import { Component, EnvironmentInjector, Inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslocoDirective } from '@jsverse/transloco';
import { localizeRoute } from 'src/app/shared/utilities/localizeRoutes';
@Component({
  selector: 'app-final-step',
  standalone: true,
  imports: [TranslocoDirective],
  templateUrl: './complete.component.html',
  styleUrl: './complete.component.css'
})
export class FinalStepComponent implements OnInit {
  propertyCode: any;

  constructor(
    private _router: Router, 
    private _activatedRoute: ActivatedRoute,
    @Inject(EnvironmentInjector) private envInjector: EnvironmentInjector) {


  }
  ngOnInit(): void {
    this.propertyCode = this._activatedRoute?.snapshot.paramMap.get('propertyCode') ?? '';
  }
  goToDetails() {
    this._router.navigate([localizeRoute(`/listing/${this.propertyCode}`, this.envInjector)], {
      queryParams: {
        isAob: true
      }
    });
  }
  protected goToListing() {
    this._router.navigate([localizeRoute(`/my-profile/listings/${this.propertyCode}`, this.envInjector)])
  }

}
